/**
 * Discount component
 * @returns <BannerDiscounts />
 */

const Discount = ({ discount, quantity, index }) => {
    const imgUrl = `${window._env_.STATIC_HOST}/static/website/images/maintenance-${quantity}.png`

    return (
        <div className="discount-item">
            <div className="discount-item__icons">
                <img src={imgUrl} />
            </div>
            <p className="discount-item__amount">{discount}%</p>
            <p className="discount-item__text">
                <strong>de descuento comprando</strong>{" "}
                {index === 0
                    ? `${quantity} mantenciones`
                    : `${quantity} o más mantenciones.`}
            </p>
        </div>
    );
};

const BannerDiscounts = ({ content }) => {
    const biggerDiscounts = content.slice(-2);

    return (
        <div className="banner-discount">
            <div className="wrapper">
                <div className="banner-discount__image">
                    <span className="banner-discount__image__gradient"></span>
                </div>

                {biggerDiscounts.map((discount, index) => (
                    <Discount
                        key={index}
                        discount={discount.discount_amount}
                        quantity={discount.quantity}
                        index={index}
                    />
                ))}
            </div>
        </div>
    );
};

export default BannerDiscounts;
